import React from 'react';
import Slider, { SliderConfiguration } from 'app_previous/elements/slider/slider';
import Slide, { SlideProps } from './Slide';
import { ArticlesSliderContainer } from './ArticlesSlider.styles';

interface ArticlesSliderProps {
  slides: SlideProps[];
  id?: string;
  sliderConfig?: SliderConfiguration;
  textColor?: string;
}

const sliderDefaultSettings = {
  infinite: false,
  draggable: true,
  dots: false,
  arrows: true,
  slidesToShow: 3,
  responsive: [
    {
      width: 1100,
      infinite: false,
      draggable: true,
      dots: false,
      arrows: true,
      slidesToShow: 2,
    },
    {
      width: 700,
      infinite: false,
      draggable: true,
      dots: false,
      arrows: true,
      slidesToShow: 1,
    },
  ],
};

const ArticlesSlider = ({ slides, id, sliderConfig = null, textColor }: ArticlesSliderProps): JSX.Element => {
  const sliderSettings = sliderConfig ?? sliderDefaultSettings;

  return (
    <ArticlesSliderContainer id={id}>
      <Slider
        {...sliderSettings}
        textColor={textColor}
      >
        {slides.map((slide, index) => (
          <Slide
            key={index}
            image={slide.image}
            title={slide.title}
            description={slide.description}
            url={slide.url}
            textColor={textColor}
          />
        ))}
      </Slider>
    </ArticlesSliderContainer>
  );
};

export default ArticlesSlider;
